import axios from 'axios'

const API_URL = process.env.VUE_APP_API_SUPPORT_URL

class ReleaseService {
  getReleaseList() {
    return axios.get(API_URL + '/release-note')
  }
}

export default new ReleaseService()
